/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue, setValue } from "@utils/lodash";
import { useNavigate } from "react-router-dom";
import NavigationBar from "@components/NotificationBar/index";
import { toast } from "react-toastify";
import ScrollableReactTable from "@components/ScrollableDatatable";
import moment from "moment";
import { adminBulkLocationUpdateStatus } from "@services/location.service";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import {
  downloadManageAuditComplianceScoreCard,
  downloadSiteMGMT,
  downloadManageAuditVenderWiseTrendsPanIndia,
  downloadManageRepeatError,
  exportManageAudit,
  generateManageAuditVendorReport,
  getManageAuditScore,
  getManageAuditScoreFilter,
  getManageAuditVendorComplianceScoreCard,
  getManageAuditVendorSiteMis,
  getManageAuditVendorWiseTrendsPanIndia,
  getRepeatErrorsandPeriodicity,
} from "@services/audit.service";
import CalenderDropdown from "@_common/CalenderDropdown";
import { formatText } from "@_common/format-text";
import { NavLink } from "react-router-dom";
import {
  convertCurrentDate,
  convertDate,
  currentDate,
} from "@_common/date-helpers";
import { tableScoreColors } from "@_common/colors";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import "chartjs-plugin-datalabels";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { countKeysWithValues, numberFormatter } from "@_common/text-helpers";
import FooterWrapper from "@components/common/FooterWrapper";
import ManageAuditNotfound from "@components/Page-Not-Found/manage-audit-not-found";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import MenuAuditSvgComponent from "../../assets/svg-components/left-menu/menuadit";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import { allParams } from "@_common/common-helper";
import { handleDownloadOnClick } from "@_common/downloadfile";
import { Popover, PopoverBody, PopoverHeader } from "reactstrap";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  ChartDataLabels
);
interface IManageAuditProps {}

const ManageAudit: React.FunctionComponent<IManageAuditProps> = (
  props: any
) => {
  let navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [listSiteMIS, setListSiteMIS] = React.useState<[]>([]);
  const [listComplianceScoreCard, setListComplianceScoreCard] = React.useState<
    []
  >([]);
  const [listVendorWiseTrends, setListVendorWiseTrends] = React.useState<[]>(
    []
  );
  const [repeatErrorsandPeriodicity, setRepeatErrorsandPeriodicity] =
    React.useState<[]>([]);

  const [filterIsOpen, setFilterIsOpen] = useState(false);
  const handleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  const [pageFilters, setpageFilters] = useState<any>([]);
  const [viewType, setViewType] = useState("");

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    // if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
    //   // getData();
    //   // getDataSiteMIS();
    //   setDate(new Date());
    //   // getRegionsList("", "");
    //   getGroupsList("", "", "");
    //   getStatesList("", "", "", "");
    //   getCitiesList("", "", "", "", "");
    //   getLocationsList("", "", "", "", "", "");
    //   getVendorList("", "", "", "", "", "", "");
    //   getAuditTypeList("", "", "", "", "", "", "", "");

    //   if (params.view_type === "SITE_MIS") {
    //     getDataSiteMIS();
    //   } else if (params.view_type === "COMPLIANCE_SCORECARD") {
    //     getDataComplianceScoreCard();
    //   } else if (params.view_type === "VENDOR-WISE_TRENDS_PAN_INDIA") {
    //     getDataVendorWiseTrends();
    //   } else if (
    //     params.view_type === "REPEAT_ERRORS_AND_PERIODICITY_OF_NON-COMPLIANCE"
    //   ) {
    //     getDataRepeatErrorsandPeriodicity();
    //   } else {
    //     getData();
    //   }
    // }

    if (props.permissionAPITriggered) {
      let filters = [
        { value: "REGION", label: "Region", id: "REGION" },
        { value: "GROUP", label: "Accounts", id: "GROUP" },
        { value: "LOCATION", label: "Sites", id: "LOCATION" },
        { value: "VENDOR", label: "Vendor", id: "VENDOR" },
        {
          value: "LINE_ITEM_WISE_REPORT",
          label: "Line Item Wise Report",
          id: "LINE_ITEM_WISE_REPORT",
        },
        {
          value: "YEAR_HISTORY",
          label: "Vendor Historical",
          id: "YEAR_HISTORY",
        },
        {
          value: "COMPLIANCE_SCORECARD",
          label: "Compliance Score Card",
          id: "COMPLIANCE_SCORECARD",
        },
        { value: "SITE_MIS", label: "Site MIS", id: "SITE_MIS" },
        {
          value: "VENDOR-WISE_TRENDS_PAN_INDIA",
          label: "Vendor-Wise Trends Pan India",
          id: "VENDOR_WISE_TRENDS_PAN_INDIA",
        },
        {
          value: "REPEAT_ERRORS_AND_PERIODICITY_OF_NON-COMPLIANCE",
          label: "Repeat Errors and Periodicity of Non-compliance",
          id: "REPEAT_ERRORS_AND_PERIODICITY_OF_NON-COMPLIANCE",
        },
      ];

      let filtered = filters.filter((item: object) =>
        getValue(item, `value`, "").toLowerCase()
      );

      if (params.view_type) {
        handleNavigateDashboard(params.view_type);
      } else {
        handleNavigateDashboard(getValue(filtered, `[${0}].value`, ""));
      }
      setpageFilters(filtered);
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      if (params.view_type === "SITE_MIS") {
        getDataSiteMIS();
      } else if (params.view_type === "COMPLIANCE_SCORECARD") {
        getDataComplianceScoreCard();
        getRegionsList("", "");
      } else if (params.view_type === "VENDOR-WISE_TRENDS_PAN_INDIA") {
        getDataVendorWiseTrends();
        getRegionsList("", "");
      } else if (
        params.view_type === "REPEAT_ERRORS_AND_PERIODICITY_OF_NON-COMPLIANCE"
      ) {
        getDataRepeatErrorsandPeriodicity();
        getRegionsList("", "");
      } else {
        getData();
        // getRegionsList("", "");
        // getGroupsList("", "", "");
        // getStatesList("", "", "", "");
        // getCitiesList("", "", "", "", "");
        // getLocationsList("","","","","","");
        // getVendorList("","","","","","","");
        // getAuditTypeList("","","","","","","","");
      }

      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }

      if (params.view_type) {
        setViewType(params.view_type);
      }
      //-----------------region & group-----------------//
      if (getValue(params, `region_id`, "")) {
        getRegionsList("", getValue(params, `region_id`, ""));
        getGroupsList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, "")
        );
      } else {
        // getRegionsList("", getValue(params, `region_id`, ""));
      }

      //-----------------state-----------------//

      if (getValue(params, `group_id`, "")) {
        getStatesList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(params, `state_id`, "")
        );
      }

      //-----------------city-----------------//

      if (getValue(params, `state_id`, "")) {
        getCitiesList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(params, `state_id`, ""),
          getValue(params, `city_id`, "")
        );
      }

      //-----------------location-----------------//
      if (getValue(params, `group_id`, "")) {
        getLocationsList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(params, `state_id`, ""),
          getValue(params, `city_id`, ""),
          getValue(params, `location_id`, "")
        );
      }
      //-----------------vendor-----------------//
      if (getValue(params, `location_id`, "")) {
        getVendorList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(request, `state_id`, ""),
          getValue(request, `city_id`, ""),
          getValue(params, `location_id`, ""),
          getValue(params, `vendor_id`, "")
        );
      }
      //-----------------audit type-----------------//
      if (getValue(params, `vendor_id`, "")) {
        getAuditTypeList(
          "",
          getValue(params, `region_id`, ""),
          getValue(params, `group_id`, ""),
          getValue(request, `state_id`, ""),
          getValue(request, `city_id`, ""),
          getValue(params, `location_id`, ""),
          getValue(params, `vendor_id`, ""),
          getValue(params, `audit_type`, "")
        );
      }

      setRequest({
        ...request,
        region_id: getValue(params, `region_id`, ""),
        group_id: getValue(params, `group_id`, ""),
        state_id: getValue(params, `state_id`, ""),
        city_id: getValue(params, `city_id`, ""),
        location_id: getValue(params, `location_id`, ""),
        vendor_id: getValue(params, `vendor_id`, ""),
        audit_type: getValue(params, `audit_type`, ""),
      });
      if (getValue(params, `region_id`, "")) {
        setFilterVisibility(true);
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let userSpec = getValue(localStorage, `user`, {});
    let user: any = JSON.parse(userSpec);

    let payload: any = {
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      // type: params.type ? params.type : "REGION",
      audit_type: params.audit_type,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      is_redirect: true,
      user_id: getValue(user, `id`, ""),
      type: params.view_type ? params.view_type : viewType,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getManageAuditScore(queryRequest);
      if (resp) {
        if (params.view_type === "REGION") {
          //------------------- Graph Section starts -------------------//
          let labelArray = getValue(resp, `data`, []).map(
            (item: any) => item.region_name
          );
          let groupArray = getValue(resp, `data`, []).map((item: any) =>
            parseInt(item.group)
          );
          let vendorArray = getValue(resp, `data`, []).map((item: any) =>
            parseInt(item.vendor)
          );
          let siteArray = getValue(resp, `data`, []).map((item: any) =>
            parseInt(item.location)
          );
          let scoreArray = getValue(resp, `data`, []).map(
            (item: any) => `${parseFloat(item.score)}`
          );

          setValue(chartData, `labels`, labelArray);
          setValue(chartData, `datasets[${0}].data`, groupArray);
          setValue(chartData, `datasets[${1}].data`, siteArray);
          setValue(chartData, `datasets[${2}].data`, vendorArray);
          setValue(chartData, `datasets[${3}].data`, scoreArray);
          setChartData({ ...chartData });
        }

        if (params.view_type === "GROUP") {
          //------------------- Graph Section starts -------------------//
          let labelArray = getValue(resp, `data`, []).map(
            (item: any) => item.group_name
          );
          let vendorArray = getValue(resp, `data`, []).map((item: any) =>
            parseInt(item.vendor)
          );
          let siteArray = getValue(resp, `data`, []).map((item: any) =>
            parseInt(item.location)
          );
          let scoreArray = getValue(resp, `data`, []).map(
            (item: any) => `${parseFloat(item.score)}`
          );

          setValue(chartDataGroup, `labels`, labelArray);
          setValue(chartDataGroup, `datasets[${0}].data`, siteArray);
          setValue(chartDataGroup, `datasets[${1}].data`, vendorArray);
          setValue(chartDataGroup, `datasets[${2}].data`, scoreArray);
          setChartDataGroup({ ...chartDataGroup });
        }

        if (params.view_type === "LOCATION") {
          //------------------- Graph Section starts -------------------//
          let labelArray = getValue(resp, `data`, []).map(
            (item: any) => item.location_name
          );
          let vendorArray = getValue(resp, `data`, []).map((item: any) =>
            parseInt(item.vendor)
          );
          let scoreArray = getValue(resp, `data`, []).map(
            (item: any) => `${parseFloat(item.score)}`
          );

          setValue(chartData, `labels`, labelArray);
          setValue(chartData, `datasets[${0}].data`, vendorArray);
          setValue(chartData, `datasets[${1}].data`, scoreArray);
          setChartData({ ...chartData });
        }

        if (params.view_type === "VENDOR") {
          //------------------- Graph Section starts -------------------//
          let labelArray = getValue(resp, `data`, []).map(
            (item: any) => item.vendor_name
          );
          let scoreArray = getValue(resp, `data`, []).map(
            (item: any) => `${parseFloat(item.score)}`
          );

          setValue(chartData, `labels`, labelArray);
          setValue(chartData, `datasets[${0}].data`, scoreArray);
          setChartData({ ...chartData });
        }

        //------------------- Graph Section Ends -------------------//

        if (params.view_type === "YEAR_HISTORY") {
          setList(
            getValue(resp, `data.data`, []).map((item: object) => ({
              ...item,
              created_at: moment(getValue(item, `created_at`, "")).format(
                "DD MMM YYYY"
              ),
              status: getValue(item, `is_active`, false)
                ? "Active"
                : "Inactive",
              city_name: getValue(item, `city.name`, ""),
            }))
          );
          setTotalCount(getValue(resp, `data.pagination.total_records`, 0));
          getRegionsList("", "");
        } else {
          setList(
            getValue(resp, `data`, []).map((item: object) => ({
              ...item,
              created_at: moment(getValue(item, `created_at`, "")).format(
                "DD MMM YYYY"
              ),
              status: getValue(item, `is_active`, false)
                ? "Active"
                : "Inactive",
              city_name: getValue(item, `city.name`, ""),
            }))
          );
          setTotalCount(getValue(resp, `data.pagination.total`, 0));
        }
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getDataSiteMIS = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let userSpec = getValue(localStorage, `user`, {});
    let user: any = JSON.parse(userSpec);

    let payload: any = {
      // month: params.date
      //   ? params.date.split("-")[1]
      //   : date
      //   ? moment(date).format("MM")
      //   : moment(dates).format("MM"),
      // year: params.date
      //   ? params.date.split("-")[0]
      //   : date
      //   ? moment(date).format("YYYY")
      //   : moment(dates).format("YYYY"),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      audit_type: params.audit_type,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      is_redirect: true,
      user_id: getValue(user, `id`, ""),
    };

    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getManageAuditVendorSiteMis(queryRequest);
      if (resp) {
        setListSiteMIS(
          getValue(resp, `data.vendors`, []).map((item: object) => ({
            ...item,
            region_name:
              getValue(item, `Region Name`, "") === "N/A"
                ? "-"
                : getValue(item, `Region Name`, ""),
            group_name:
              getValue(item, `Group Name`, "") === "N/A"
                ? "-"
                : getValue(item, `Group Name`, ""),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getDataComplianceScoreCard = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let userSpec = getValue(localStorage, `user`, {});
    let user: any = JSON.parse(userSpec);

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      // audit_type: params.audit_type,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      is_redirect: true,
      user_id: getValue(user, `id`, ""),
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
    };

    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getManageAuditVendorComplianceScoreCard(queryRequest);
      if (resp) {
        setListComplianceScoreCard(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            region_name:
              getValue(item, `Region Name`, "") === "N/A"
                ? "-"
                : getValue(item, `Region Name`, ""),
            group_name:
              getValue(item, `Group Name`, "") === "N/A"
                ? "-"
                : getValue(item, `Group Name`, ""),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getDataVendorWiseTrends = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let userSpec = getValue(localStorage, `user`, {});
    let user: any = JSON.parse(userSpec);
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      // is_redirect: true,
      user_id: getValue(user, `id`, ""),
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getManageAuditVendorWiseTrendsPanIndia(queryRequest);
      if (resp) {
        setListVendorWiseTrends(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            region_name:
              getValue(item, `region_name`, "") === "N/A"
                ? "-"
                : getValue(item, `region_name`, ""),
            group_name:
              getValue(item, `Group Name`, "") === "N/A"
                ? "-"
                : getValue(item, `Group Name`, ""),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getDataRepeatErrorsandPeriodicity = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let userSpec = getValue(localStorage, `user`, {});
    let user: any = JSON.parse(userSpec);
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      // is_redirect: true,
      user_id: getValue(user, `id`, ""),
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await getRepeatErrorsandPeriodicity(queryRequest);
      if (resp) {
        setRepeatErrorsandPeriodicity(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            region_name:
              getValue(item, `region_name`, "") === "N/A"
                ? "-"
                : getValue(item, `region_name`, ""),
            group_name:
              getValue(item, `Group Name`, "") === "N/A"
                ? "-"
                : getValue(item, `Group Name`, ""),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      // getData();
      if (params.view_type === "SITE_MIS") {
        getDataSiteMIS();
      } else if (params.view_type === "COMPLIANCE_SCORECARD") {
        getDataComplianceScoreCard();
      } else if (params.view_type === "VENDOR-WISE_TRENDS_PAN_INDIA") {
        getDataVendorWiseTrends();
      } else if (
        params.view_type === "REPEAT_ERRORS_AND_PERIODICITY_OF_NON-COMPLIANCE"
      ) {
        getDataRepeatErrorsandPeriodicity();
      } else {
        getData();
      }
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      // getData();
      if (params.view_type === "SITE_MIS") {
        getDataSiteMIS();
      } else if (params.view_type === "COMPLIANCE_SCORECARD") {
        getDataComplianceScoreCard();
      } else if (params.view_type === "VENDOR-WISE_TRENDS_PAN_INDIA") {
        getDataVendorWiseTrends();
      } else if (
        params.view_type === "REPEAT_ERRORS_AND_PERIODICITY_OF_NON-COMPLIANCE"
      ) {
        getDataRepeatErrorsandPeriodicity();
      } else {
        getData();
      }
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const rowClick = (obj: any) => {
    // navigate(
    //   `/audit/manage-audit/group/${obj.original.region_id}?${mainQueryRequest}`
    // );
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };

  const columns1 = React.useMemo(
    () => [
      {
        Header: "Region Name",
        accessor: "region_name",
        width: 100,
        Cell: ({ row }: any) => {
          return (
            <>
              <NavLink
                to={`/audit/manage-audit/group/${row.original.region_id}?${mainQueryRequest}`}
              >
                {row.values.region_name}
              </NavLink>
            </>
          );
        },
      },
      {
        Header: "Accounts",
        accessor: "group",
        width: 80,
      },
      {
        Header: "Sites",
        accessor: "location",
        width: 80,
      },
      {
        Header: "Vendors",
        accessor: "vendor",
        width: 80,
      },
      {
        Header: "Submitted",
        accessor: "uploaded",
        width: 90,
      },
      {
        Header: "Not Submitted",
        accessor: "not_uploaded",
        width: 110,
      },

      {
        Header: "Headcount",
        accessor: "manpower",
        width: 100,
        Cell: ({ row }: any) => {
          return (
            <div className="headcount-button">
              {getValue(row, `values.manpower`, 0)
                ? numberFormatter(getValue(row, `values.manpower`, 0))
                : 0}
            </div>
          );
        },
      },
      {
        Header: "Overall Score",
        accessor: "score",
        width: 120,
        Cell: ({ row }: any) => {
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  getValue(row, `values.score`, 0)
                    ? parseFloat(getValue(row, `values.score`, 0))
                    : 0
                ),
              }}
            >
              {/* {getValue(row, `values.score`, "- -") > 0
                ? `${getValue(row, `values.score`, "- -")}%`
                : "- -"} */}
              {getValue(row, `values.score`, null) === null
                ? "- -"
                : `${getValue(row, `values.score`, 0)}%`}
            </div>
          );
        },
      },
      {
        Header: "1MP Score",
        accessor: "prev_month_1_score",
        width: 120,
        Cell: ({ row }: any) => {
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  getValue(row, `values.prev_month_1_score`, 0)
                    ? parseFloat(getValue(row, `values.prev_month_1_score`, 0))
                    : 0
                ),
              }}
            >
              {/* {getValue(row, `values.prev_month_1_score`, "- -") > 0
                ? `${getValue(row, `values.prev_month_1_score`, "- -")}%`
                : " - -"} */}
              {getValue(row, `values.prev_month_1_score`, null) === null
                ? "- -"
                : `${getValue(row, `values.prev_month_1_score`, 0)}%`}
            </div>
          );
        },
      },
      {
        Header: "2MP Score",
        accessor: "prev_month_2_score",
        width: 120,
        Cell: ({ row }: any) => {
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  getValue(row, `values.prev_month_2_score`, 0)
                    ? parseFloat(getValue(row, `values.prev_month_2_score`, 0))
                    : 0
                ),
              }}
            >
              {/* {getValue(row, `values.prev_month_2_score`, "- -") > 0
                ? `${getValue(row, `values.prev_month_2_score`, "- -")}%`
                : "- -"} */}
              {getValue(row, `values.prev_month_2_score`, null) === null
                ? "- -"
                : `${getValue(row, `values.prev_month_2_score`, 0)}%`}
            </div>
          );
        },
      },
      {
        Header: "3MP Score",
        accessor: "prev_month_3_score",
        width: 120,
        Cell: ({ row }: any) => {
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  getValue(row, `values.prev_month_3_score`, 0)
                    ? parseFloat(getValue(row, `values.prev_month_3_score`, 0))
                    : 0
                ),
              }}
            >
              {/* {getValue(row, `values.prev_month_3_score`, "- -") > 0
                ? `${getValue(row, `values.prev_month_3_score`, "- -")}%`
                : "- -"} */}
              {getValue(row, `values.prev_month_3_score`, null) === null
                ? "- -"
                : `${getValue(row, `values.prev_month_3_score`, 0)}%`}
            </div>
          );
        },
      },
    ],
    []
  );

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const dateParam = params?.date ? new Date(params.date) : new Date();

  const getMonthNameWithYear = (date: Date, offset: number) => {
    const adjustedDate = new Date(date);
    adjustedDate.setMonth(date.getMonth() - offset); // Subtract months to get previous month
    const month = adjustedDate.toLocaleString("default", { month: "short" });
    const year = adjustedDate.getFullYear().toString().slice(-2);
    return `${month}-${year}`;
  };

  // Use the new function to get month-year combinations
  const currentMonthName = getMonthNameWithYear(dateParam, 0);
  const prevMonth1Name = getMonthNameWithYear(dateParam, 1);
  const prevMonth2Name = getMonthNameWithYear(dateParam, 2);
  const prevMonth3Name = getMonthNameWithYear(dateParam, 3);

  const columns = React.useMemo(() => {
    const baseColumns = [
      {
        // Header: "Overall Score",
        Header: `${currentMonthName} Score`,
        accessor: "score",
        width: 120,
        Cell: ({ row }: any) => (
          <div
            className="score-button"
            style={{
              backgroundColor: tableScoreColors(
                getValue(row, `values.score`, 0)
                  ? parseFloat(getValue(row, `values.score`, 0))
                  : 0
              ),
            }}
          >
            {getValue(row, `values.score`, null) === null
              ? "- -"
              : `${getValue(row, `values.score`, 0)}%`}
          </div>
        ),
      },
      {
        // Header: "1MP Score",
        Header: `${prevMonth1Name} Score`,
        accessor: "prev_month_1_score",
        width: 120,
        Cell: ({ row }: any) => {
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  getValue(row, `values.prev_month_1_score`, 0)
                    ? parseFloat(getValue(row, `values.prev_month_1_score`, 0))
                    : 0
                ),
              }}
            >
              {getValue(row, `values.prev_month_1_score`, null) === null
                ? "- -"
                : `${getValue(row, `values.prev_month_1_score`, 0)}%`}
            </div>
          );
        },
      },
      {
        // Header: "2MP Score",
        Header: `${prevMonth2Name} Score`,
        accessor: "prev_month_2_score",
        width: 120,
        Cell: ({ row }: any) => {
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  getValue(row, `values.prev_month_2_score`, 0)
                    ? parseFloat(getValue(row, `values.prev_month_2_score`, 0))
                    : 0
                ),
              }}
            >
              {getValue(row, `values.prev_month_2_score`, null) === null
                ? "- -"
                : `${getValue(row, `values.prev_month_2_score`, 0)}%`}
            </div>
          );
        },
      },
      {
        // Header: "3MP Score",
        Header: `${prevMonth3Name} Score`,
        accessor: "prev_month_3_score",
        width: 120,
        Cell: ({ row }: any) => {
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  getValue(row, `values.prev_month_3_score`, 0)
                    ? parseFloat(getValue(row, `values.prev_month_3_score`, 0))
                    : 0
                ),
              }}
            >
              {getValue(row, `values.prev_month_3_score`, null) === null
                ? "- -"
                : `${getValue(row, `values.prev_month_3_score`, 0)}%`}
            </div>
          );
        },
      },
    ];

    // Conditionally add the "Region Name" column
    if (params.view_type === "REGION") {
      baseColumns.splice(0, 0, {
        Header: "Region Name",
        accessor: "region_name",
        width: 120,
        Cell: ({ row }: any) => {
          const regionId = row.original.region_id;
          const updatedQueryRequest = `${allParams()}&region_id=${regionId}`;
          return (
            <NavLink to={`/audit/manage-audit/group?${updatedQueryRequest}`}>
              {row.values.region_name}
            </NavLink>
          );
        },
      });

      baseColumns.splice(6, 0, {
        Header: "Accounts",
        accessor: "group",
        width: 80,
        Cell: ({ row }: any) => {
          return <>{row.values.group}</>;
        },
      });

      baseColumns.splice(7, 0, {
        Header: "Sites",
        accessor: "location",
        width: 80,
        Cell: ({ row }: any) => {
          return <>{row.values.location}</>;
        },
      });

      baseColumns.splice(8, 0, {
        Header: "Vendors",
        accessor: "vendor",
        width: 80,
        Cell: ({ row }: any) => {
          return <>{row.values.vendor}</>;
        },
      });
      baseColumns.splice(9, 0, {
        Header: "Absent",
        accessor: "absent_sites",
        width: 100,
        Cell: ({ row }: any) => {
          return <>{row.values.absent_sites}</>;
        },
      });
      baseColumns.splice(10, 0, {
        Header: "Submitted Sites",
        accessor: "locations_all_submitted",
        width: 80,
        Cell: ({ row }: any) => {
          return <>{row.values.locations_all_submitted}</>;
        },
      });
      baseColumns.splice(11, 0, {
        Header: "Partially Submitted Sites",
        accessor: "locations_partial_submission",
        width: 120,
        Cell: ({ row }: any) => {
          return <>{row.values.locations_partial_submission}</>;
        },
      });
      baseColumns.splice(12, 0, {
        Header: "Not Submitted Sites",
        accessor: "locations_no_submission",
        width: 100,
        Cell: ({ row }: any) => {
          return <>{row.values.locations_no_submission}</>;
        },
      });
    }

    // Conditionally add the "Group Name" column
    if (params.view_type === "GROUP") {
      baseColumns.splice(0, 0, {
        Header: "Account Name",
        accessor: "group_name",
        width: 150,
        Cell: ({ row }: any) => {
          const groupId = row.original.group_id;
          const updatedQueryRequest = `${allParams()}&group_id=${groupId}`;

          return (
            <NavLink to={`/audit/manage-audit/location?${updatedQueryRequest}`}>
              {row.values.group_name}
            </NavLink>
          );
        },
      });
      baseColumns.splice(6, 0, {
        Header: "Sites",
        accessor: "location",
        width: 80,
        Cell: ({ row }: any) => {
          return <>{row.values.location}</>;
        },
      });

      baseColumns.splice(7, 0, {
        Header: "Vendors",
        accessor: "vendor",
        width: 80,
        Cell: ({ row }: any) => {
          return <>{row.values.vendor}</>;
        },
      });
      baseColumns.splice(8, 0, {
        Header: "Absent",
        accessor: "absent_sites",
        width: 100,
        Cell: ({ row }: any) => {
          return <>{row.values.absent_sites}</>;
        },
      });
      baseColumns.splice(9, 0, {
        Header: "Submitted Sites",
        accessor: "locations_all_submitted",
        width: 80,
        Cell: ({ row }: any) => {
          return <>{row.values.locations_all_submitted}</>;
        },
      });
      baseColumns.splice(10, 0, {
        Header: "Partially Submitted Sites",
        accessor: "locations_partial_submission",
        width: 120,
        Cell: ({ row }: any) => {
          return <>{row.values.locations_partial_submission}</>;
        },
      });
      baseColumns.splice(11, 0, {
        Header: "Not Submitted Sites",
        accessor: "locations_no_submission",
        width: 100,
        Cell: ({ row }: any) => {
          return <>{row.values.locations_no_submission}</>;
        },
      });

      // baseColumns.push({
      //   Header: "1MP Score",
      //   accessor: "prev_month_1_score",
      //   width: 120,
      //   Cell: ({ row }: any) => {
      //     return (
      //       <div
      //         className="score-button"
      //         style={{
      //           backgroundColor: tableScoreColors(
      //             getValue(row, `values.prev_month_1_score`, 0)
      //               ? parseFloat(getValue(row, `values.prev_month_1_score`, 0))
      //               : 0
      //           ),
      //         }}
      //       >
      //         {getValue(row, `values.prev_month_1_score`, null) === null
      //             ? "- -"
      //             : `${getValue(row, `values.prev_month_1_score`, 0)}%`
      //           }
      //       </div>
      //     );
      //   },
      // },);

      // baseColumns.push({
      //   Header: "2MP Score",
      //   accessor: "prev_month_2_score",
      //   width: 120,
      //   Cell: ({ row }: any) => {
      //     return (
      //       <div
      //         className="score-button"
      //         style={{
      //           backgroundColor: tableScoreColors(
      //             getValue(row, `values.prev_month_2_score`, 0)
      //               ? parseFloat(getValue(row, `values.prev_month_2_score`, 0))
      //               : 0
      //           ),
      //         }}
      //       >
      //         {getValue(row, `values.prev_month_2_score`, null) === null
      //             ? "- -"
      //             : `${getValue(row, `values.prev_month_2_score`, 0)}%`
      //           }
      //       </div>
      //     );
      //   },
      // },);

      // baseColumns.push({
      //   Header: "3MP Score",
      //   accessor: "prev_month_3_score",
      //   width: 120,
      //   Cell: ({ row }: any) => {
      //     return (
      //       <div
      //         className="score-button"
      //         style={{
      //           backgroundColor: tableScoreColors(
      //             getValue(row, `values.prev_month_3_score`, 0)
      //               ? parseFloat(getValue(row, `values.prev_month_3_score`, 0))
      //               : 0
      //           ),
      //         }}
      //       >
      //         {getValue(row, `values.prev_month_3_score`, null) === null
      //             ? "- -"
      //             : `${getValue(row, `values.prev_month_3_score`, 0)}%`
      //           }
      //       </div>
      //     );
      //   },
      // },)
    }

    if (params.view_type === "LOCATION") {
      baseColumns.splice(0, 0, {
        Header: "Site Name",
        accessor: "location_name",
        width: 150,
        Cell: ({ row }: any) => {
          const location_id = row.original.location_id;
          const updatedQueryRequest = `${allParams()}&location_id=${location_id}`;

          return (
            <NavLink to={`/audit/manage-audit/vendor?${updatedQueryRequest}`}>
              {row.values.location_name}
            </NavLink>
          );
        },
      });

      baseColumns.splice(5, 0, {
        Header: "Vendors",
        accessor: "vendor",
        width: 80,
        Cell: ({ row }: any) => {
          return <>{row.values.vendor}</>;
        },
      });
      baseColumns.splice(6, 0, {
        Header: "Absent",
        accessor: "absent_sites",
        width: 100,
        Cell: ({ row }: any) => {
          return <>{row.values.absent_sites}</>;
        },
      });
      baseColumns.splice(7, 0, {
        Header: "Submited Checkpoint",
        accessor: "uploaded",
        width: 150,
        Cell: ({ row }: any) => {
          return <>{row.values.uploaded}</>;
        },
      });
      baseColumns.splice(8, 0, {
        Header: "Not Submited Checkpoint",
        accessor: "not_uploaded",
        width: 180,
        Cell: ({ row }: any) => {
          return <>{row.values.not_uploaded}</>;
        },
      });

      // baseColumns.push({
      //   Header: "Action",
      //   accessor: "",
      //   width: 150,
      //   Cell: ({ row }: any) => {
      //     return (
      //       <>
      //         <div
      //           className="download-button"
      //           onClick={(e) => handleDownloadReport(e, row.original.vendor_id)}
      //         >
      //           Download Report
      //         </div>
      //       </>
      //     );
      //   },
      // },);
    }

    if (params.view_type === "VENDOR") {
      baseColumns.splice(0, 0, {
        Header: "Vendor Name",
        accessor: "vendor_name",
        width: 200,
        Cell: ({ row }: any) => {
          const vendor_id = row.original.vendor_id;
          const updatedQueryRequest = `${allParams()}&vendor_id=${vendor_id}`;
          return (
            <NavLink to={`/audit/manage-audit/location?${updatedQueryRequest}`}>
              {row.values.vendor_name}
            </NavLink>
          );
        },
      });
      baseColumns.splice(5, 0, {
        Header: "Absent",
        // accessor: "locations_all_submitted",
        accessor: "absent_sites",
        width: 100,
        Cell: ({ row }: any) => {
          return <>{row.values.absent_sites}</>;
        },
      });

      baseColumns.splice(6, 0, {
        Header: "Uploaded",
        // accessor: "locations_all_submitted",
        accessor: "uploaded",
        width: 80,
        Cell: ({ row }: any) => {
          return <>{row.values.uploaded}</>;
        },
      });
      baseColumns.splice(7, 0, {
        Header: "Not Uploaded",
        // accessor: "locations_partial_submission",
        accessor: "not_uploaded",
        width: 120,
        Cell: ({ row }: any) => {
          return <>{row.values.not_uploaded}</>;
        },
      });
      // baseColumns.splice(3,0,{
      //   Header: "Not Submitted",
      //   accessor: "locations_no_submission",
      //   width: 110,
      //   Cell: ({ row }: any) => {
      //     return (
      //       <>
      //         {row.values.locations_no_submission}
      //       </>
      //     );
      //   }
      // });

      // baseColumns.push({
      //   Header: "Action",
      //   accessor: "",
      //   width: 150,
      //   Cell: ({ row }: any) => {
      //     return (
      //       <>
      //         <div
      //           className="download-button"
      //           onClick={(e) => handleDownloadReport(e, row.original.vendor_id)}
      //         >
      //           Download Report
      //         </div>
      //       </>
      //     );
      //   },
      // },);
    }

    baseColumns.push({
      Header: "Headcount",
      accessor: "manpower",
      width: 80,
      Cell: ({ row }: any) => {
        return (
          <div className="headcount-button">
            {getValue(row, `values.manpower`, 0)
              ? numberFormatter(getValue(row, `values.manpower`, 0))
              : 0}
          </div>
        );
      },
    });
    return baseColumns;
  }, [params.view_type, params.date]);

  const year = params?.date
    ? new Date(params.date).getFullYear()
    : new Date().getFullYear();

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const columnsYearHistory = React.useMemo(
    () => [
      {
        Header: "Vendor Name",
        accessor: "vendor_name",
        width: 180,
      },
      ...months.map((month) => ({
        Header: `${month} ${year}`,
        accessor: `${month.toLowerCase()}_score`, // Example: jan_score
        width: 80,
        Cell: ({ row }: any) => {
          const score = getValue(
            row,
            `values.${month.toLowerCase()}_score`,
            null
          );
          const parsedScore = score !== null ? parseFloat(score) : null;

          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(parsedScore ?? 0), // Use color logic
              }}
            >
              {parsedScore === null ? "- -" : `${parsedScore}%`}
            </div>
          );
        },
      })),
    ],
    [params.view_type, params.date]
  );

  const columnsComplianceScoreCard = React.useMemo(
    () => [
      // {
      //   Header: "Month of Audit",
      //   accessor: "month",
      //   width: 180,
      // },

      {
        Header: "Month of Audit",
        accessor: "month",
        width: 110,
        Cell: ({ value }: any) => {
          // const year = params?.date ? new Date(params.date).getFullYear() : new Date().getFullYear();
          let dates = date ? date : new Date();
          const year = params.date
            ? params.date.split("-")[0]
            : date
            ? moment(date).format("YYYY")
            : moment(dates).format("YYYY");
          const monthNames = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];
          return `${monthNames[value - 1]} ${year}`;
        },
      },
      {
        Header: "Total Sites",
        accessor: "total_sites",
        width: 100,
      },
      {
        Header: "Total Vendors",
        accessor: "total_vendors",
        width: 120,
      },
      {
        Header: "Absent",
        accessor: "sites_with_no_submissions_percentage",
        width: 150,
        Cell: ({ row }: any) => {
          const value = getValue(
            row,
            `values.sites_with_no_submissions_percentage`,
            null
          );
          console.log(row, "==row==>");
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  value ? parseFloat(value) : 0
                ),
                width: "80px",
              }}
            >
              &nbsp;
              {getValue(row, `original.sites_with_no_submissions`, "")} (
              {value === null ? "- -" : `${value}%`})
            </div>
          );
        },
      },
      {
        Header: "Critical",
        accessor: "critical_non_complied_percentage",
        width: 150,
        Cell: ({ row }: any) => {
          const value = getValue(
            row,
            `values.critical_non_complied_percentage`,
            null
          );
          console.log(row, "==row==>");
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  value ? parseFloat(value) : 0
                ),
              }}
            >
              {value === null ? "- -" : `${value}%`}
            </div>
          );
        },
      },
      {
        Header: "Full",
        accessor: "compliance_score",
        width: 150,
        Cell: ({ row }: any) => {
          const value = getValue(row, `values.compliance_score`, null);
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  value ? parseFloat(value) : 0
                ),
              }}
            >
              {value === null ? "- -" : `${value}%`}
            </div>
          );
        },
      },
      {
        Header: "Non Critical",
        accessor: "non_critical_non_complied_percentage",
        width: 150,
        Cell: ({ row }: any) => {
          const value = getValue(
            row,
            `values.non_critical_non_complied_percentage`,
            null
          );
          return (
            <div
              className="score-button"
              style={{
                backgroundColor: tableScoreColors(
                  value ? parseFloat(value) : 0
                ),
              }}
            >
              {value === null ? "- -" : `${value}%`}
            </div>
          );
        },
      },
    ],
    [params.view_type, params.date]
  );

  const VendorWiseTrendsColumns = React.useMemo(
    () => [
      {
        Header: "Month",
        accessor: "month",
        width: 110,
        Cell: ({ value }: any) => {
          let dates = date ? date : new Date();
          const year = params.date
            ? params.date.split("-")[0]
            : date
            ? moment(date).format("YYYY")
            : moment(dates).format("YYYY");
          const monthNames = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];
          return `${monthNames[value - 1]} ${year}`;
        },
      },
      {
        Header: "Region",
        accessor: "region_name",
        width: 150,
        Cell: ({ row }: any) => {
          const urlSearchParams = new URLSearchParams(window.location.search);
          const params = Object.fromEntries(urlSearchParams.entries());
          const selectedDate = params.date
            ? params.date
            : date
            ? moment(date).format("YYYY-MM-DD")
            : moment(new Date()).format("YYYY-MM-DD");
          const viewType = "REGION";
          return (
            <NavLink
              to={`/audit/manage-audit?date=${selectedDate}&view_type=${viewType}`}
            >
              {row.values.region_name}
            </NavLink>
          );
        },
      },
      {
        Header: "Account Name",
        accessor: "account_name",
        width: 150,
      },
      {
        Header: "Site Name",
        accessor: "site_name",
        width: 150,
      },
      {
        Header: "Vendor Name",
        accessor: "vendor_name",
        width: 150,
      },
      {
        Header: "City",
        accessor: "city_name",
        width: 150,
      },
      {
        Header: "State",
        accessor: "state_name",
        width: 150,
      },
      {
        Header: "Trends",
        accessor: "trend",
        width: 120,
        Cell: ({ row }: any) => {
          const value = getValue(row, `values.trend`, "").toLowerCase();
          let backgroundColor = "";
          let textColor = "#000";
          switch (value) {
            case "poor":
              backgroundColor = "#eb4034";
              textColor = "#fff";
              break;
            case "excellent":
              backgroundColor = "#28a745";
              textColor = "#fff";
              break;
            case "good":
              backgroundColor = "#d4edda";
              textColor = "#fff";
              break;
            case "average":
              backgroundColor = "#c3e6cb";
              textColor = "#fff";
              break;
            default:
              backgroundColor = "";
              textColor = "#000";
          }
          return (
            <div
              style={{
                width: "90px",
                padding: "4px",
                backgroundColor,
                color: textColor,
                textAlign: "center",
                borderRadius: "4px",
                fontWeight: 500,
              }}
            >
              {value ? value.charAt(0).toUpperCase() + value.slice(1) : "-"}
            </div>
          );
        },
      },
    ],
    [params.view_type, params.date]
  );

  const RepeatErrorsandPeriodicityColumns = React.useMemo(
    () => [
      {
        Header: "Month",
        accessor: "month",
        width: 110,
        Cell: ({ value }: any) => {
          let dates = date ? date : new Date();
          const year = params.date
            ? params.date.split("-")[0]
            : date
            ? moment(date).format("YYYY")
            : moment(dates).format("YYYY");
          const monthNames = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ];
          return `${monthNames[value - 1]} ${year}`;
        },
      },
      {
        Header: "Account Name",
        accessor: "account_name",
        width: 120,
      },
      {
        Header: "Site Name",
        accessor: "site_name",
        width: 120,
      },
      {
        Header: "Vendor Name",
        accessor: "vendor_name",
        width: 120,
      },
      {
        Header: "City",
        accessor: "city_name",
        width: 120,
      },
      {
        Header: "State",
        accessor: "state_name",
        width: 120,
      },
      {
        Header: "Labor Legislation/Act",
        accessor: "labor_legislation_act",
        width: 160,
      },
      {
        Header: "Particulars of Legislation",
        accessor: "particulars_of_legislation",
        width: 160,
      },

      {
        Header: "Compliance Status",
        accessor: "compliance_status",
        width: 160,
        Cell: ({ row }: any) => {
          const value = getValue(row, `values.compliance_status`, "");
          const backgroundColor =
            value === "Non-Complied"
              ? "#f73307" // light red
              : "";

          return (
            <div
              style={{
                width: "90px",
                padding: "4px",
                backgroundColor: backgroundColor,
                color: value === "Non-Complied" ? "#fff" : "#000",
                textAlign: "center",
                borderRadius: "4px",
                fontWeight: 500,
              }}
            >
              {value}
            </div>
          );
        },
      },

      {
        Header: "Periodicity of Non-Compliance (Count)",
        accessor: "periodicity_count",
        width: 160,
      },
    ],
    [params.view_type, params.date]
  );

  // const columnsSiteMis = React.useMemo(
  //   () => [
  //     {
  //       Header: "Vendor Name",
  //       accessor: "vendor_name",
  //       width: 100,
  //     },
  //     {
  //       Header: "Location",
  //       accessor: "location_name",
  //       width: 150,
  //       Cell: ({ row }: any) => {
  //         const locations = row.original.locations;
  //         const [popoverOpen, setPopoverOpen] = useState(false);
  //         const togglePopover = () => setPopoverOpen(!popoverOpen);
  //         const handleMouseEnter = () => setPopoverOpen(true);
  //         const handleMouseLeave = () => setPopoverOpen(false);

  //         return (
  //           <>
  //             {locations.length > 0 && (
  //               <div>
  //                 {locations[0].location_name}
  //                 {locations.length > 1 && (
  //                   <>
  //                     <span
  //                       id={`location-popover-${row.id}`}
  //                       style={{ cursor: 'pointer', marginLeft: '5px', color: 'blue' }}
  //                       onMouseEnter={handleMouseEnter}
  //                       onMouseLeave={handleMouseLeave}
  //                     >
  //                       + {locations.length - 1}
  //                     </span>
  //                     <Popover
  //                       placement="bottom"
  //                       isOpen={popoverOpen}
  //                       target={`location-popover-${row.id}`}
  //                       toggle={togglePopover}
  //                     >
  //                       <PopoverHeader>Additional Locations</PopoverHeader>
  //                       <PopoverBody>
  //                         {locations.slice(1).map((location: any, index: any) => (
  //                           <div key={index}>{location.location_name}</div>
  //                         ))}
  //                       </PopoverBody>
  //                     </Popover>
  //                   </>
  //                 )}
  //               </div>
  //             )}
  //           </>
  //         );
  //       },
  //     },
  //     {
  //       Header: "Users",
  //       accessor: "users",
  //       width: 150,
  //       Cell: ({ row }: any) => {
  //         const locations = row.original.locations || []; // Get all locations
  //         const [popoverOpen, setPopoverOpen] = useState(false);

  //         const handleMouseEnter = () => setPopoverOpen(true);
  //         const handleMouseLeave = () => setPopoverOpen(false);

  //         // Flatten all users from all locations
  //         const allUsers = locations.flatMap((location: any) => location.users || []);

  //         return (
  //           <>
  //             {allUsers.length > 0 && (
  //               <div>
  //                 {allUsers[0].email} {/* Display the first user's email */}
  //                 {allUsers.length > 1 && (
  //                   <>
  //                     <span
  //                       id={`user-popover-${row.id}`}
  //                       style={{ cursor: 'pointer', marginLeft: '5px', color: 'blue' }}
  //                       onMouseEnter={handleMouseEnter}
  //                       onMouseLeave={handleMouseLeave}
  //                     >
  //                       + {allUsers.length - 1}
  //                     </span>
  //                     <Popover
  //                       placement="bottom"
  //                       isOpen={popoverOpen}
  //                       target={`user-popover-${row.id}`}
  //                       toggle={() => {}}
  //                     >
  //                       <PopoverHeader>Additional Users</PopoverHeader>
  //                       <PopoverBody>
  //                         {allUsers.slice(1).map((user: any, index: any) => (
  //                           <div key={index}>{user.email}</div>
  //                         ))}
  //                       </PopoverBody>
  //                     </Popover>
  //                   </>
  //                 )}
  //               </div>
  //             )}
  //           </>
  //         );
  //       },
  //     },
  //     {
  //       Header: "Status",
  //       accessor: "status",
  //       width: 150,
  //     },
  //     {
  //       Header: "Create At",
  //       accessor: "created_at",
  //       width: 150,
  //     },
  //   ],
  //   []
  // );

  const columnsSiteMis = React.useMemo(
    () => [
      {
        Header: "Site",
        accessor: "Site Name",
        width: 100,
      },
      {
        Header: "Region",
        accessor: "region_name",
        width: 100,
      },

      {
        Header: "Account",
        accessor: "group_name",
        width: 100,
      },
      {
        Header: "State",
        accessor: "State",
        width: 100,
      },
      {
        Header: "City",
        accessor: "City",
        width: 100,
      },
      {
        Header: "Vendor Name",
        accessor: "Vendor Name",
        width: 100,
      },
      {
        Header: "Users Email",
        accessor: "Users Email",
        width: 200,
        Cell: ({ row }: any) => {
          const emails =
            row.original["Users Email"]
              ?.split(",")
              .map((email: string) => email.trim()) || [];
          const [popoverOpen, setPopoverOpen] = useState(false);
          const togglePopover = () => setPopoverOpen(!popoverOpen);
          const handleMouseEnter = () => setPopoverOpen(true);
          const handleMouseLeave = () => setPopoverOpen(false);

          return (
            <>
              {emails.length > 0 && (
                <div>
                  {emails[0]}
                  {emails.length > 1 && (
                    <>
                      <span
                        id={`email-popover-${row.id}`}
                        style={{
                          cursor: "pointer",
                          marginLeft: "5px",
                          color: "blue",
                        }}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                      >
                        + {emails.length - 1}
                      </span>
                      <Popover
                        placement="bottom"
                        isOpen={popoverOpen}
                        target={`email-popover-${row.id}`}
                        toggle={togglePopover}
                      >
                        <PopoverHeader>Additional Users Emails</PopoverHeader>
                        <PopoverBody style={{ padding: "5px" }}>
                          {emails
                            .slice(1)
                            .map((email: string, index: number) => (
                              <div key={index}>{email}</div>
                            ))}
                        </PopoverBody>
                      </Popover>
                    </>
                  )}
                </div>
              )}
            </>
          );
        },
      },

      {
        Header: "To Emails",
        accessor: "To Emails",
        width: 200,
        Cell: ({ row }: any) => {
          const rawEmails = row.original["To Emails"];
          const formattedEmails =
            rawEmails && rawEmails !== "N/A"
              ? rawEmails
                  .split(/[,|]/)
                  .map((email: string) => email.trim())
                  .filter(Boolean)
              : [];

          const [popoverOpen, setPopoverOpen] = useState(false);
          const togglePopover = () => setPopoverOpen(!popoverOpen);
          const handleMouseEnter = () => setPopoverOpen(true);
          const handleMouseLeave = () => setPopoverOpen(false);

          return (
            <>
              {formattedEmails.length > 0 ? (
                <div>
                  {formattedEmails[0]}
                  {formattedEmails.length > 1 && (
                    <>
                      <span
                        id={`to-email-popover-${row.id}`}
                        style={{
                          cursor: "pointer",
                          marginLeft: "5px",
                          color: "blue",
                        }}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                      >
                        + {formattedEmails.length - 1}
                      </span>
                      <Popover
                        placement="bottom"
                        isOpen={popoverOpen}
                        target={`to-email-popover-${row.id}`}
                        toggle={togglePopover}
                      >
                        <PopoverHeader>Additional To Emails</PopoverHeader>
                        <PopoverBody style={{ padding: "5px" }}>
                          {formattedEmails
                            .slice(1)
                            .map((email: string, index: number) => (
                              <div key={index}>{email}</div>
                            ))}
                        </PopoverBody>
                      </Popover>
                    </>
                  )}
                </div>
              ) : (
                <span>-</span>
              )}
            </>
          );
        },
      },
      {
        Header: "CC Emails",
        accessor: "CC Emails",
        width: 200,
        Cell: ({ row }: any) => {
          const rawEmails = row.original["CC Emails"];
          const formattedEmails =
            rawEmails && rawEmails !== "N/A"
              ? rawEmails
                  .split(/[,|]/)
                  .map((email: string) => email.trim())
                  .filter(Boolean)
              : [];

          const [popoverOpen, setPopoverOpen] = useState(false);
          const togglePopover = () => setPopoverOpen(!popoverOpen);
          const handleMouseEnter = () => setPopoverOpen(true);
          const handleMouseLeave = () => setPopoverOpen(false);

          return (
            <>
              {formattedEmails.length > 0 ? (
                <div>
                  {formattedEmails[0]}
                  {formattedEmails.length > 1 && (
                    <>
                      <span
                        id={`cc-email-popover-${row.id}`}
                        style={{
                          cursor: "pointer",
                          marginLeft: "5px",
                          color: "blue",
                        }}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                      >
                        + {formattedEmails.length - 1}
                      </span>
                      <Popover
                        placement="bottom"
                        isOpen={popoverOpen}
                        target={`cc-email-popover-${row.id}`}
                        toggle={togglePopover}
                      >
                        <PopoverHeader>Additional CC Emails</PopoverHeader>
                        <PopoverBody style={{ padding: "5px" }}>
                          {formattedEmails
                            .slice(1)
                            .map((email: string, index: number) => (
                              <div key={index}>{email}</div>
                            ))}
                        </PopoverBody>
                      </Popover>
                    </>
                  )}
                </div>
              ) : (
                <span>-</span>
              )}
            </>
          );
        },
      },
    ],
    [params.view_type, params.date]
  );

  const handleDownloadReport = async (e: any, vendor_id: string) => {
    e.stopPropagation();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload: any = {
        report_type: "VENDOR_AUDIT_SCORE",
        report_name: `vendor_audit_score_${currentDate()}`,
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: params.region_id,
        group_id: params.group_id,
        location_id: params.location_id,
        vendor_id: vendor_id,
        audit_type: params.audit_type,
      };
      payload.month = parseInt(payload.month);
      payload.region_id = parseInt(payload.region_id);

      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let resp = await generateManageAuditVendorReport(payload);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/VENDOR_AUDIT_SCORE`);
      }
    } catch (error) {}
  };

  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await adminBulkLocationUpdateStatus({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        // getData();
        if (params.view_type === "SITE_MIS") {
          getDataSiteMIS();
        } else if (params.view_type === "COMPLIANCE_SCORECARD") {
          getDataComplianceScoreCard();
        } else if (params.view_type === "VENDOR-WISE_TRENDS_PAN_INDIA") {
          getDataVendorWiseTrends();
        } else if (
          params.view_type === "REPEAT_ERRORS_AND_PERIODICITY_OF_NON-COMPLIANCE"
        ) {
          getDataRepeatErrorsandPeriodicity();
        } else {
          getData();
        }
      } else {
        // getData();
        if (params.view_type === "SITE_MIS") {
          getDataSiteMIS();
        } else if (params.view_type === "COMPLIANCE_SCORECARD") {
          getDataComplianceScoreCard();
        } else if (params.view_type === "VENDOR-WISE_TRENDS_PAN_INDIA") {
          getDataVendorWiseTrends();
        } else if (
          params.view_type === "REPEAT_ERRORS_AND_PERIODICITY_OF_NON-COMPLIANCE"
        ) {
          getDataRepeatErrorsandPeriodicity();
        } else {
          getData();
        }
      }
    } catch (error) {}
  };

  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Date section                                 */
  /* -------------------------------------------------------------------------- */

  const [date, setDate] = useState<Date | null>(null);
  const handleSubmitDate = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = moment(date).format("YYYY-MM-DD");
    if (dates && dates !== "Invalid date") {
      let payload: any = {
        ...params,
        date: dates,
      };

      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      toast.error("Please select date");
    }
  };

  const handleNavigate = (bodyObj: object) => {
    navigate(
      `/audit/details/${getValue(bodyObj, `vendor_id`, "")}/${moment(
        date
      ).format("YYYY-MM-DD")}/uploaded/${getValue(bodyObj, `vendor_name`, "")}`
    );
  };
  const urlParamsFun = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let D = date ? date : new Date();
    let dates = params.date ? convertDate(params.date) : convertDate(D);
    let request = QueryRequestHelper({ ...params, date: dates });
    return request;
  };

  const mainQueryRequest = useMemo(
    () => urlParamsFun(),
    [window.location.href]
  );
  /* -------------------------------------------------------------------------- */
  /*                        smart Filter section                                */
  /* -------------------------------------------------------------------------- */
  const [request, setRequest] = useState<any>({
    state_id: "",
    city_id: "",
    region_id: "",
    group_id: "",
    location_id: "",
    vendor_id: "",
    audit_type: "",
  });
  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
      date: getValue(params, `date`, ""),
      view_type: params.view_type, // Preserve view_type
    };
    setRequest({
      ...request,
      state_id: "",
      city_id: "",
      region_id: "",
      group_id: "",
      location_id: "",
      vendor_id: "",
      audit_type: "",
    });
    setGroupsList([]);
    setStateList([]);
    setCityList([]);
    setlocationsList([]);
    setvendorsList([]);
    setAuditTypeList([]);
    getRegionsList("", "");
    getGroupsList("", "", "");
    getStatesList("", "", "", "");
    getCitiesList("", "", "", "", "");
    getLocationsList("", "", "", "", "", "");
    getVendorList("", "", "", "", "", "", "");
    getAuditTypeList("", "", "", "", "", "", "", "");
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    // getData();
    if (params.view_type === "SITE_MIS") {
      getDataSiteMIS();
    } else if (params.view_type === "COMPLIANCE_SCORECARD") {
      getDataComplianceScoreCard();
    } else if (params.view_type === "VENDOR-WISE_TRENDS_PAN_INDIA") {
      getDataVendorWiseTrends();
    } else if (
      params.view_type === "REPEAT_ERRORS_AND_PERIODICITY_OF_NON-COMPLIANCE"
    ) {
      getDataRepeatErrorsandPeriodicity();
    } else {
      getData();
    }

    setFilterVisibility(false);
  };

  const [isFilterVisible, setFilterVisibility] = React.useState(false);

  /* -------------------------------------------------------------------------- */
  /*                    smart Filter API section                                */
  /* -------------------------------------------------------------------------- */

  const [regionList, setRegionList] = useState([]);
  const [regionLoading, setRegionLoading] = useState(false);
  const getRegionsList = async (search_text: string, id: string) => {
    // const urlSearchParams = new URLSearchParams(window.location.search);
    // const params = Object.fromEntries(urlSearchParams.entries());
    // let dates = date ? date : new Date();
    // try {
    //   let payload = {
    //     month: params.date
    //       ? params.date.split("-")[1]
    //       : date
    //       ? moment(date).format("MM")
    //       : moment(dates).format("MM"),
    //     year: params.date
    //       ? params.date.split("-")[0]
    //       : date
    //       ? moment(date).format("YYYY")
    //       : moment(dates).format("YYYY"),
    //     type: "REGION",
    //     search_text: search_text,
    //     region_id: id,
    //     is_redirect: true,
    //   };
    //   setRegionLoading(true);
    //   let queryRequest = QueryRequestHelper(payload);
    //   let resp = await getManageAuditScoreFilter(queryRequest);
    //   if (resp) {
    //     setRegionList(
    //       getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
    //         ...item,
    //         id: getValue(item, `region_id`, ""),
    //         label: getValue(item, `region_name`, ""),
    //         value: getValue(item, `region_name`, ""),
    //       }))
    //     );
    //     setRegionLoading(false);
    //   } else {
    //     setRegionLoading(false);
    //   }
    // } catch (error) {
    //   setRegionLoading(false);
    // }
    // if (!search_text) {
    //   // setRequest({
    //   //   ...request,
    //   //   region_id: "",
    //   // });
    //   //   getGroupsList("", "");
    //   //   setGroupsList([]);
    //   //   getLocationsList("", "", "");
    //   //   setlocationsList([]);
    //   //   getVendorList("", "", "", "");
    //   //   setvendorsList([]);
    // }
  };

  const [groupsList, setGroupsList] = useState([]);
  const [groupLoading, setGroupLoading] = useState(false);
  const getGroupsList = async (
    search_text: string,
    region_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        type: "GROUP",
        search_text: search_text,
        group_id: id,
        is_redirect: true,
      };
      setGroupLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setGroupsList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `group_id`, ""),
            label: getValue(item, `group_name`, ""),
            value: getValue(item, `group_name`, ""),
          }))
        );
        setGroupLoading(false);
      } else {
        setGroupLoading(false);
      }
    } catch (error) {
      setGroupLoading(false);
    }
    if (!search_text) {
      // setRequest({
      //   ...request,
      //   group_id: null,
      // });
      //   getLocationsList("", "", "");
      //   setlocationsList([]);
      //   getVendorList("", "", "", "");
      //   setvendorsList([]);
    }
  };

  const [stateList, setStateList] = useState([]);
  const [stateLoading, setStateLoading] = useState(false);
  const getStatesList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        type: "STATE",
        search_text: search_text,
        state_id: id,
        is_redirect: true,
      };

      setStateLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setStateList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `state_id`, ""),
            label: getValue(item, `state_name`, ""),
            value: getValue(item, `state_name`, ""),
          }))
        );
        setStateLoading(false);
      } else {
        setStateLoading(false);
      }
    } catch (error) {
      setStateLoading(false);
    }
  };

  const [cityList, setCityList] = useState([]);
  const [cityLoading, setCityLoading] = useState(false);
  const getCitiesList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        type: "CITY",
        search_text: search_text,
        state_id: state_id,
        city_id: id,
        is_redirect: true,
      };

      setCityLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setCityList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `city_id`, ""),
            label: getValue(item, `city_name`, ""),
            value: getValue(item, `city_name`, ""),
          }))
        );
        setCityLoading(false);
      } else {
        setCityLoading(false);
      }
    } catch (error) {
      setCityLoading(false);
    }
  };

  const [locationsList, setlocationsList] = useState([]);
  const [locationLoading, setLocationLoading] = useState(false);
  const getLocationsList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        type: "LOCATION",
        search_text: search_text,
        state_id: state_id,
        city_id: city_id,
        location_id: id,
        is_redirect: true,
      };
      setLocationLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setlocationsList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `location_id`, ""),
            label: getValue(item, `location_name`, ""),
            value: getValue(item, `location_name`, ""),
          }))
        );
        setLocationLoading(false);
      } else {
        setLocationLoading(false);
      }
    } catch (error) {
      setLocationLoading(false);
    }
  };

  const [vendorsList, setvendorsList] = useState([]);
  const [vendorLoading, setvendorLoading] = useState(false);
  const getVendorList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    location_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        state_id: state_id,
        city_id: city_id,
        location_id: location_id,
        type: "VENDOR",
        search_text: search_text,
        vendor_id: id,
        is_redirect: true,
      };
      setvendorLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setvendorsList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `vendor_id`, ""),
            label: getValue(item, `vendor_name`, ""),
            value: getValue(item, `vendor_name`, ""),
          }))
        );
        setvendorLoading(false);
      } else {
        setvendorLoading(false);
      }
    } catch (error) {
      setvendorLoading(false);
    }
  };

  const [auditTypeList, setAuditTypeList] = useState([]);
  const [auditTypeLoading, setAuditTypeLoading] = useState(false);
  const getAuditTypeList = async (
    search_text: string,
    region_id: string,
    group_id: string,
    state_id: string,
    city_id: string,
    location_id: string,
    vendor_id: string,
    id: string
  ) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? params.date.split("-")[1]
          : date
          ? moment(date).format("MM")
          : moment(dates).format("MM"),
        year: params.date
          ? params.date.split("-")[0]
          : date
          ? moment(date).format("YYYY")
          : moment(dates).format("YYYY"),
        region_id: region_id,
        group_id: group_id,
        state_id: state_id,
        city_id: city_id,
        location_id: location_id,
        vendor_id: vendor_id,
        type: "AUDIT_TYPE",
        search_text: search_text,
        audit_type: id,
        is_redirect: true,
      };
      setAuditTypeLoading(true);
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getManageAuditScoreFilter(queryRequest);
      if (resp) {
        setAuditTypeList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `audit_status`, ""),
            label: formatText(getValue(item, `audit_status`, "")),
            value: getValue(item, `audit_status`, ""),
          }))
        );
        setAuditTypeLoading(false);
      } else {
        setAuditTypeLoading(false);
      }
    } catch (error) {
      setAuditTypeLoading(false);
    }
    if (!search_text) {
      // setRequest({
      //   ...request,
      //   vendor_id: "",
      // });
    }
  };

  const handleRemoveFilter = (name: string) => {
    if (name === "region_id") {
      setRequest({
        ...request,
        region_id: "",
        group_id: "",
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      getRegionsList("", "");
      getGroupsList("", "", "");
      getStatesList("", "", "", "");
      getCitiesList("", "", "", "", "");
      getLocationsList("", "", "", "", "", "");
      getVendorList("", "", "", "", "", "", "");
      getAuditTypeList("", "", "", "", "", "", "", "");

      setGroupsList([]);
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }
    if (name === "group_id") {
      setRequest({
        ...request,
        group_id: "",
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getGroupsList("", getValue(request, `region_id`, ""), "");
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }

    if (name === "state_id") {
      setRequest({
        ...request,
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getStatesList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        ""
      );
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }

    if (name === "city_id") {
      setRequest({
        ...request,
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      getCitiesList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        ""
      );
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }

    if (name === "location_id") {
      setRequest({
        ...request,
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      // getGroupsList("", getValue(request, `region_id`, ""), "");
      getLocationsList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        ""
      );
      setvendorsList([]);
      setAuditTypeList([]);
    }
    if (name === "vendor_id") {
      setRequest({
        ...request,
        vendor_id: "",
        audit_type: "",
      });
      // getRegionsList("", "");
      // getGroupsList("", getValue(request, `region_id`, ""), "");
      // getLocationsList(
      //   "",
      //   getValue(request, `region_id`, ""),
      //   getValue(request, `group_id`, ""),
      //   ""
      // );
      getVendorList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        getValue(request, `location_id`, ""),
        ""
      );
      setAuditTypeList([]);
    }
    if (name === "audit_type") {
      setRequest({
        ...request,
        audit_type: "",
      });
      // getRegionsList("", "");
      // getGroupsList("", getValue(request, `region_id`, ""), "");
      // getLocationsList(
      //   "",
      //   getValue(request, `region_id`, ""),
      //   getValue(request, `group_id`, ""),
      //   ""
      // );
      // getVendorList(
      //   "",
      //   getValue(request, `region_id`, ""),
      //   getValue(request, `group_id`, ""),
      //   getValue(request, `location_id`, ""),
      //   ""
      // );
      getAuditTypeList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),

        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),

        getValue(request, `location_id`, ""),
        getValue(request, `vendor_id`, ""),
        ""
      );
    }
    // getRegionsList("", "");
    // getGroupsList("", "", "");
    // getStatesList("", "", "", "");
    // getCitiesList("", "", "", "", "");
    // getLocationsList("","","","","","");
    // getVendorList("","","","","","","");
    // getAuditTypeList("","","","","","","","");
  };

  const handleSelectFilter = (id: any, name: string) => {
    if (name === "region_id") {
      getGroupsList("", id, "");
      setRequest({
        ...request,
        group_id: "",
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      setGroupsList([]);
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }
    if (name === "group_id") {
      getStatesList("", getValue(request, `region_id`, ""), id, "");
      setRequest({
        ...request,
        state_id: "",
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      setStateList([]);
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }

    if (name === "state_id") {
      getCitiesList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        city_id: "",
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      setCityList([]);
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }

    if (name === "city_id") {
      getLocationsList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        location_id: "",
        vendor_id: "",
        audit_type: "",
      });
      setlocationsList([]);
      setvendorsList([]);
      setAuditTypeList([]);
    }

    if (name === "location_id") {
      getVendorList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        vendor_id: "",
        audit_type: "",
      });
      setvendorsList([]);
      setAuditTypeList([]);
    }

    if (name === "vendor_id") {
      getAuditTypeList(
        "",
        getValue(request, `region_id`, ""),
        getValue(request, `group_id`, ""),
        getValue(request, `state_id`, ""),
        getValue(request, `city_id`, ""),
        getValue(request, `location_id`, ""),
        id,
        ""
      );
      setRequest({
        ...request,
        audit_type: "",
      });
      setAuditTypeList([]);
    }

    setRequest({
      ...request,
      [name]: id,
    });
  };

  const handleSubmitSmartFilter = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      country_id: getValue(request, `country_id`, ""),
      state_id: getValue(request, `state_id`, ""),
      city_id: getValue(request, `city_id`, ""),
      region_id: getValue(request, `region_id`, ""),
      group_id: getValue(request, `group_id`, ""),
      location_id: getValue(request, `location_id`, ""),
      vendor_id: getValue(request, `vendor_id`, ""),
      audit_type: getValue(request, `audit_type`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    // handleFilter();
  };

  let state_ID =
    getValue(stateList, `length`, 0) > 0 &&
    stateList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, "")
    );

  let city_ID =
    getValue(cityList, `length`, 0) > 0 &&
    cityList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `city_id`, "")
    );
  let region_ID =
    getValue(regionList, `length`, 0) > 0 &&
    regionList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `region_id`, "")
    );

  let group_ID =
    getValue(groupsList, `length`, 0) > 0 &&
    groupsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `group_id`, "")
    );

  let location_ID =
    getValue(locationsList, `length`, 0) > 0 &&
    locationsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `location_id`, "")
    );

  let vendor_ID =
    getValue(vendorsList, `length`, 0) > 0 &&
    vendorsList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `vendor_id`, "")
    );

  let audit_type_ID =
    getValue(auditTypeList, `length`, 0) > 0 &&
    auditTypeList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `audit_type`, "")
    );
  /* -------------------------------------------------------------------------- */
  /*                               Chart section                                */
  /* -------------------------------------------------------------------------- */

  const handleChangeView = (view: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      view: view,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const [chartData, setChartData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Accounts",
        data: [0],
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "Sites",
        data: [0],
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
      {
        label: "Vendors",
        data: [0],
        backgroundColor: "rgba(200, 162, 255, 0.5)",
      },
      {
        label: "Overall Score (%)",
        data: [0],
        backgroundColor: "rgba(255, 99, 132, 0.2)",
      },
    ],
  });

  const [chartDataGroup, setChartDataGroup] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Sites",
        data: [0],
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
      {
        label: "Vendors",
        data: [0],
        backgroundColor: "rgba(200, 162, 255, 0.5)",
      },
      {
        label: "Overall Score (%)",
        data: [0],
        backgroundColor: "rgba(255, 99, 132, 0.2)",
      },
    ],
  });
  const handleOnClickBarChart = (index: number) => {
    let selectedList = list.filter((_item: any, i: number) => index === i);
    let item = getValue(selectedList, `[${0}]`, "");
    const regionId = getValue(item, `region_id`, "");
    const updatedQueryRequest = `${mainQueryRequest}&region_id=${regionId}`;
    navigate(`/audit/manage-audit/group?${updatedQueryRequest}`);
  };

  const options = {
    responsive: true,
    plugins: {
      datalabels: {
        labels: {
          value: {
            color: "black",
            font: {
              size: 13,
            },
          },
        },
        formatter: (val: any) => {
          // return val ? `${val}${val ? "%" : ""}` : "";
          return val;
        },
      },
      legend: {
        position: "top" as const,
      },
      title: {
        display: true,
        text: "Region Level Breakup",
      },
    },
  };

  // View As Filter

  const handleNavigateDashboard = (value: string) => {
    // const urlSearchParams = new URLSearchParams(window.location.search);
    // const params = Object.fromEntries(urlSearchParams.entries());
    // let payload: any = {
    //   ...params,
    //   view_type: value,
    // };
    // if (value) {
    //   let queryRequest = QueryRequestHelper(payload);
    //   navigate(`${window.location.pathname}?${queryRequest}`);
    // } else {
    //   delete params.view_type;
    //   let queryRequest = QueryRequestHelper(payload);
    //   navigate(`${window.location.pathname}?${queryRequest}`);
    // }
    if (value === "LINE_ITEM_WISE_REPORT") {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload: any = {
        ...params,
      };

      let queryRequest = QueryRequestHelper(payload);
      navigate(`/repository/vendor-compliance/master?${queryRequest}`);
    } else {
      // reset();
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.page_no;
      delete params.region_id;
      delete params.group_id;
      delete params.state_id;
      delete params.city_id;
      delete params.location_id;
      delete params.vendor_id;

      let payload: any = {
        ...params,
        view_type: value,
      };
      if (value) {
        let queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        delete params.view_type;
        let queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      }
      setPage_no(1);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                             Download Reports                               */
  /* -------------------------------------------------------------------------- */
  const [downloadLoading, setDownloadLoading] = useState(false);
  const handleDownloadSelfComplianceReport = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let userSpec = getValue(localStorage, `user`, {});
    let user: any = JSON.parse(userSpec);

    let payload: any = {
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      // type: params.type ? params.type : "REGION",
      audit_type: params.audit_type,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      is_redirect: true,
      user_id: getValue(user, `id`, ""),
      type: params.view_type ? params.view_type : viewType,
    };

    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });

    let queryRequest = QueryRequestHelper(payload);
    setDownloadLoading(true);
    try {
      let resp = await exportManageAudit(queryRequest);
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        // navigate(`/self-compliance-logs/SELFCOMP_MY_TASKS`);
        handleDownloadOnClick(
          getValue(resp, `data.downloadUrl`, ""),
          "Manage Audit"
        );
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };

  const handleDownloadSelfComplianceReportSITEMIS = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();

    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    let payload: any = {
      // month: params.date
      //   ? params.date.split("-")[1]
      //   : date
      //   ? moment(date).format("MM")
      //   : moment(dates).format("MM"),
      month: params.date
        ? parseInt(params.date.split("-")[1])
        : date
        ? parseInt(moment(date).format("MM"))
        : parseInt(moment(dates).format("MM")),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      search_text: params.search_text,
      sort_by: params.sort_by,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      // type: params.type ? params.type : "REGION",
      audit_type: params.audit_type,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      is_redirect: "true",
      report_type: "SITE_MANAGEMENT_REPORT",
      report_name: `Site Mis - ${convertCurrentDate(
        from_date
      )} to ${convertCurrentDate(to_date)}`,
      page_size: 100,
    };

    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });

    // let queryRequest = QueryRequestHelper(payload);
    setDownloadLoading(true);
    try {
      let resp = await downloadSiteMGMT(payload);
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/SITE_MANAGEMENT_REPORT`);
        // handleDownloadOnClick(
        //   getValue(resp, `data.downloadUrl`, ""),
        //   "Manage Audit"
        // );
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };

  const handleDownloadVendorWiseTrendsPanIndia = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();

    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    let payload: any = {
      month: params.date
        ? parseInt(params.date.split("-")[1])
        : date
        ? parseInt(moment(date).format("MM"))
        : parseInt(moment(dates).format("MM")),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      audit_type: params.audit_type,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      is_redirect: "true",
      report_description: "VENDOR_WISE_TRENDS_AUDIT_REPORT",
      report_type: "VENDOR_WISE_TRENDS_AUDIT_REPORT",
      report_name: `Vendor-wise-trends - ${convertCurrentDate(
        from_date
      )} to ${convertCurrentDate(to_date)}`,
    };

    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    setDownloadLoading(true);
    try {
      let resp = await downloadManageAuditVenderWiseTrendsPanIndia(payload);
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/VENDOR_WISE_TRENDS_AUDIT_REPORT`);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };

  const handleDownloadSelfComplianceYearHistory = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();

    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    let userSpec = getValue(localStorage, `user`, {});
    let user: any = JSON.parse(userSpec);

    let payload: any = {
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      // month: params.date
      //   ? parseInt(params.date.split("-")[1])
      //   : date
      //   ? parseInt(moment(date).format("MM"))
      //   : parseInt(moment(dates).format("MM")),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      region_id: params.region_id,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      user_id: getValue(user, `id`, ""),
      type: "YEAR_HISTORY",
      audit_type: params.audit_type,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      is_redirect: "true",
      report_description: "VENDOR_AUDIT_SCORE_CARD",
      report_type: "VENDOR_AUDIT_SCORE_CARD",
      report_name: `Vendor History - ${convertCurrentDate(
        from_date
      )} to ${convertCurrentDate(to_date)}`,
    };

    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });

    // let queryRequest = QueryRequestHelper(payload)
    setDownloadLoading(true);
    try {
      let resp = await downloadManageAuditComplianceScoreCard(payload);
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/VENDOR_AUDIT_SCORE_CARD`);
        // handleDownloadOnClick(
        //   getValue(resp, `data.downloadUrl`, ""),
        //   "Manage Audit"
        // );
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };

  const handleDownloadRepeatError = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();

    var from_date = params.from_date
      ? params.from_date
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.to_date
      ? params.to_date
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    let payload: any = {
      month: params.date
        ? parseInt(params.date.split("-")[1])
        : date
        ? parseInt(moment(date).format("MM"))
        : parseInt(moment(dates).format("MM")),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      group_id: params.group_id,
      location_id: params.location_id,
      vendor_id: params.vendor_id,
      state_id: getValue(params, `state_id`, ""),
      city_id: getValue(params, `city_id`, ""),
      is_redirect: "true",
      report_description: "REPEAT_ERRORS_AND_PERIODICITY_OF_NON-COMPLIANCE",
      report_type: "REPEAT_ERRORS_AND_PERIODICITY_OF_NON-COMPLIANCE",
      report_name: `Repeat-error- ${convertCurrentDate(
        from_date
      )} to ${convertCurrentDate(to_date)}`,
    };

    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    setDownloadLoading(true);
    try {
      let resp = await downloadManageRepeatError(payload);
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(
          `/self-compliance-logs/REPEAT_ERRORS_AND_PERIODICITY_OF_NON-COMPLIANCE`
        );
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };

  const handleNavigateLogsSiteMis = () => {
    navigate(`/self-compliance-logs/VENDOR_MANAGE_AUDIT_SITE_MIS_REPORT`);
  };

  const handleNavigateLogsYearHistory = () => {
    navigate(`/self-compliance-logs/VENDOR_AUDIT_SCORE_CARD`);
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "audit_manage_audit"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <NavigationBar
              selectedIDs={selectedIDs}
              isMarkInactiveSectionVisible={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              handleChangeActiveStatus={handleChangeActiveStatus}
              text={"MARK INACTIVE"}
              multi={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              handleRemoveNavItems={handleRemoveNavItems}
            />
          )}
          <div className="dashboard-wrapper__header d-flex justify-content-between d-none">
            <h4 className="dashbaord-wrapper__header-title">Manage Audit</h4>
            <div className="d-flex align-items-center">
              <div
                className="d-flex cursor-pointer"
                onClick={() =>
                  handleChangeView(!getValue(params, `view`, "") ? "graph" : "")
                }
              >
                <img
                  src={`/images/${
                    getValue(params, `view`, "") === "graph"
                      ? "list"
                      : "bar_graph"
                  }.png`}
                  style={{ height: "30px", width: "30px", marginRight: "20px" }}
                  alt=""
                />
              </div>
              <CalenderDropdown
                value={date}
                onChange={setDate}
                handleSubmitDate={handleSubmitDate}
              />
            </div>
          </div>

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MenuAuditSvgComponent />
              </div>
              {getValue(pageFilters, "length", 0) > 1 ? (
                <div className="module-filter-wrapper mt-3 ms-2 manage-audit-view-filter">
                  <div className="module_filter_fields_wrapper">
                    <label htmlFor="is_configured" className="floating-label">
                      View by
                    </label>
                    <SearchableDropdownSelect
                      placeholder={"Choose View by"}
                      options={pageFilters}
                      handleChange={(e: any) =>
                        handleNavigateDashboard(getValue(e, `value`, ""))
                      }
                      handleClick={(e: any) =>
                        handleNavigateDashboard(getValue(e, `value`, ""))
                      }
                      value={
                        getValue(pageFilters, `length`, 0) > 0
                          ? pageFilters.find(
                              (item: object) =>
                                getValue(item, `value`, "") == viewType
                            )
                          : {}
                      }
                      className="form-control"
                      name="compliance_type_id"
                      label="label"
                      id="id"
                      removeClose
                    />
                  </div>
                </div>
              ) : null}
            </div>

            <div className="d-flex align-items-center">
              <div
                className="d-flex cursor-pointer d-none"
                onClick={() =>
                  handleChangeView(!getValue(params, `view`, "") ? "graph" : "")
                }
              >
                <img
                  src={`/images/${
                    getValue(params, `view`, "") === "graph"
                      ? "list"
                      : "bar_graph"
                  }.png`}
                  style={{ height: "30px", width: "30px", marginRight: "20px" }}
                  alt=""
                />
              </div>
              <RightMenuHeaders
                monthYear={!["SITE_MIS"].includes(params.view_type)}
                value={date}
                onChange={setDate}
                handleSubmitDate={handleSubmitDate}
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                smartFilter={false}
                handleFilter={handleFilter}
                lineSeperator={true}
                selectedFilterCount={countKeysWithValues(params)}
                downloadSelfComplianceReport={
                  !["COMPLIANCE_SCORECARD"].includes(params.view_type)
                }
                handleDownloadSelfComplianceReport={
                  params.view_type === "SITE_MIS"
                    ? handleDownloadSelfComplianceReportSITEMIS
                    : params.view_type === "YEAR_HISTORY"
                    ? handleDownloadSelfComplianceYearHistory
                    : params.view_type === "VENDOR-WISE_TRENDS_PAN_INDIA"
                    ? handleDownloadVendorWiseTrendsPanIndia
                    : params.view_type ===
                      "REPEAT_ERRORS_AND_PERIODICITY_OF_NON-COMPLIANCE"
                    ? handleDownloadRepeatError
                    : handleDownloadSelfComplianceReport
                }
                downloadLoading={downloadLoading}
                viewDownloadedSelfComplianceReports={
                  params.view_type === "SITE_MIS" ||
                  params.view_type === "YEAR_HISTORY"
                }
                handleNavigateLogs={
                  params.view_type === "SITE_MIS"
                    ? handleNavigateLogsSiteMis
                    : handleNavigateLogsYearHistory
                }
              />
            </div>
          </div>

          <div
            className={`main-page-layout-wrapper`}
            id={
              getValue(selectedIDs, `length`, 0) > 0
                ? "blueNavigationVisible"
                : ""
            }
          >
            <div className="admin-wrapper position-relative">
              {/* {isFilterVisible && ( */}
              {/* <ManageAuditFilterForm
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  reset={reset}
                  handleSubmitSmartFilter={handleSubmitSmartFilter}
                  //region
                  regionLoading={regionLoading}
                  regionList={regionList}
                  region_ID={region_ID}
                  getRegionsList={getRegionsList}
                  //group
                  groupLoading={groupLoading}
                  groupsList={groupsList}
                  group_ID={group_ID}
                  getGroupsList={getGroupsList}
                  //state
                  stateLoading={stateLoading}
                  stateList={stateList}
                  state_ID={state_ID}
                  getStatesList={getStatesList}
                  //city
                  cityLoading={cityLoading}
                  cityList={cityList}
                  city_ID={city_ID}
                  getCitiesList={getCitiesList}
                  //location
                  locationLoading={locationLoading}
                  locationsList={locationsList}
                  location_ID={location_ID}
                  getLocationsList={getLocationsList}
                  //configuration/vendors
                  vendorLoading={vendorLoading}
                  vendorsList={vendorsList}
                  vendor_ID={vendor_ID}
                  getVendorList={getVendorList}
                  //audit_type
                  auditTypeLoading={auditTypeLoading}
                  auditTypeList={auditTypeList}
                  audit_type_ID={audit_type_ID}
                  getAuditTypeList={getAuditTypeList}
                  //above common funs
                  request={request}
                  handleSelectFilter={handleSelectFilter}
                  handleRemoveFilter={handleRemoveFilter}
                  filterIsOpen={filterIsOpen}
                  handleFilter={handleFilter}
                  moduleName={"Audit"}
                  subModuleName={"Manage Audit"}
                /> */}
              {/* )} */}

              {/* d-flex align-items-center justify-content-between */}

              {(params.view_type === "YEAR_HISTORY" ||
                params.view_type === "COMPLIANCE_SCORECARD" ||
                params.view_type === "VENDOR-WISE_TRENDS_PAN_INDIA" ||
                params.view_type ===
                  "REPEAT_ERRORS_AND_PERIODICITY_OF_NON-COMPLIANCE") && (
                <div className="filter-section-wrap module-filter-wrapper">
                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        Region
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Select Region`}
                        options={regionList}
                        searchLoading={regionLoading}
                        handleChange={(val: any) =>
                          val
                            ? getRegionsList(val, "")
                            : handleRemoveFilter("region_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(getValue(e, `id`, ""), "region_id")
                        }
                        value={
                          Array.isArray(region_ID) && region_ID.length > 0
                            ? region_ID[0]
                            : ""
                        }
                        label="label"
                        id="id"
                        name={"region_id"}
                      />
                    </div>
                  </div>
                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        Account
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Select Account`}
                        options={groupsList}
                        searchLoading={groupLoading}
                        handleChange={(val: any) =>
                          val
                            ? getGroupsList(
                                val,
                                getValue(request, `group_id`, ""),
                                ""
                              )
                            : handleRemoveFilter("group_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(getValue(e, `id`, ""), "group_id")
                        }
                        // value={group_ID}
                        value={
                          Array.isArray(group_ID) && group_ID.length > 0
                            ? group_ID[0]
                            : ""
                        }
                        label="label"
                        id="id"
                        name={"group_id"}
                      />
                    </div>
                  </div>

                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        State
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Choose State`}
                        options={stateList}
                        searchLoading={stateLoading}
                        handleChange={(val: any) =>
                          val
                            ? getStatesList(
                                val,
                                getValue(request, `region_id`, ""),
                                getValue(request, `group_id`, ""),
                                // getValue(props, `request.state_id`, ""),
                                ""
                              )
                            : handleRemoveFilter("state_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(getValue(e, `id`, ""), "state_id")
                        }
                        value={
                          Array.isArray(state_ID) && state_ID.length > 0
                            ? state_ID[0]
                            : ""
                        }
                        label="label"
                        id="id"
                        name={"state_id"}
                      />
                    </div>
                  </div>

                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        City
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Choose City`}
                        options={cityList}
                        searchLoading={cityLoading}
                        handleChange={(val: any) =>
                          val
                            ? getCitiesList(
                                val,
                                getValue(request, `region_id`, ""),
                                getValue(request, `group_id`, ""),
                                getValue(request, `state_id`, ""),
                                // getValue(props, `request.city_id`, ""),
                                ""
                              )
                            : handleRemoveFilter("city_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(getValue(e, `id`, ""), "city_id")
                        }
                        // value={getValue(props, `city_ID[${0}]`, "")}
                        value={
                          Array.isArray(city_ID) && city_ID.length > 0
                            ? city_ID[0]
                            : ""
                        }
                        label="label"
                        id="id"
                        name={"city_id"}
                      />
                    </div>
                  </div>

                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        Site
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Select Site`}
                        options={locationsList}
                        searchLoading={locationLoading}
                        handleChange={(val: any) =>
                          val
                            ? getLocationsList(
                                val,
                                getValue(request, `region_id`, ""),
                                getValue(request, `group_id`, ""),
                                getValue(request, `state_id`, ""),
                                getValue(request, `city_id`, ""),
                                ""
                              )
                            : handleRemoveFilter("location_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(
                            getValue(e, `id`, ""),
                            "location_id"
                          )
                        }
                        // value={location_ID}
                        value={
                          Array.isArray(location_ID) && location_ID.length > 0
                            ? location_ID[0]
                            : ""
                        }
                        x
                        label="label"
                        id="id"
                        name={"location_id"}
                        // removeClose
                      />
                    </div>
                  </div>

                  <div className="width-20">
                    <div className="filter-form-wrappper__location-input module_filter_fields_wrapper">
                      <label htmlFor="country_id" className="floating-label">
                        Vendor
                      </label>
                      <SearchableDropdownSelect
                        placeholder={`Select Vendor`}
                        options={vendorsList}
                        searchLoading={vendorLoading}
                        handleChange={(val: any) =>
                          val
                            ? getVendorList(
                                val,
                                getValue(request, `region_id`, ""),
                                getValue(request, `group_id`, ""),
                                getValue(request, `state_id`, ""),
                                getValue(request, `city_id`, ""),
                                getValue(request, `location_id`, ""),
                                ""
                              )
                            : handleRemoveFilter("vendor_id")
                        }
                        handleClick={(e: any) =>
                          handleSelectFilter(getValue(e, `id`, ""), "vendor_id")
                        }
                        value={
                          Array.isArray(vendor_ID) && vendor_ID.length > 0
                            ? vendor_ID[0]
                            : ""
                        }
                        label="label"
                        id="id"
                        name={"vendor_id"}
                        // removeClose
                        disabled={props.disableVendor}
                      />
                    </div>
                  </div>

                  <div className="width-18">
                    <div className="filter-form-wrappper__cta-wrapper">
                      <button
                        className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search btn btn-primary"
                        onClick={handleSubmitSmartFilter}
                      >
                        Search
                      </button>
                      <button
                        className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset btn"
                        onClick={reset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : // list.length > 0 || listSiteMIS.length > 0 || listComplianceScoreCard.length > 0 ? (
              (params.view_type === "SITE_MIS" && listSiteMIS.length > 0) ||
                (params.view_type === "COMPLIANCE_SCORECARD" &&
                  listComplianceScoreCard.length > 0) ||
                (params.view_type === "VENDOR-WISE_TRENDS_PAN_INDIA" &&
                  listVendorWiseTrends.length > 0) ||
                (params.view_type ===
                  "REPEAT_ERRORS_AND_PERIODICITY_OF_NON-COMPLIANCE" &&
                  repeatErrorsandPeriodicity.length > 0) ||
                (params.view_type !== "SITE_MIS" &&
                  params.view_type !== "COMPLIANCE_SCORECARD" &&
                  list.length > 0) ? (
                <>
                  {getValue(params, `view`, "") === "graph" ? (
                    <div className="manage_audit_chart-view">
                      <Bar
                        // data={chartData}
                        data={
                          params.view_type === "REGION"
                            ? chartData
                            : params.view_type === "GROUP"
                            ? chartDataGroup
                            : chartData // Default for other types
                        }
                        options={{
                          ...options,
                          responsive: true,
                          maintainAspectRatio: true,
                          onClick: function (evt, element) {
                            let ind = getValue(element, `[${0}].index`, null);
                            if (element.length > 0) {
                              handleOnClickBarChart(ind);
                            }
                          },
                        }}
                      />
                    </div>
                  ) : (
                    <>
                      {/* {(params.view_type === "VENDOR_HISTORICAL") && (
                        <>
                          VENDOR_HISTORICAL
                        </>
                      )}

                      <ScrollableReactTable
                        columns={columns}
                        data={list}
                        getTableState={getTableState}
                        rowClick={rowClick}
                        check={check}
                        selectedIDs={selectedIDs}
                        getTrProps={getTrProps}
                        checkboxlogo
                      /> */}
                      {params.view_type === "YEAR_HISTORY" ? (
                        <>
                          <ScrollableReactTable
                            columns={columnsYearHistory}
                            data={list}
                            getTableState={getTableState}
                            rowClick={rowClick}
                            check={check}
                            selectedIDs={selectedIDs}
                            getTrProps={getTrProps}
                            x
                            checkboxlogo
                          />
                        </>
                      ) : params.view_type === "COMPLIANCE_SCORECARD" ? (
                        <>
                          <ScrollableReactTable
                            columns={columnsComplianceScoreCard}
                            data={listComplianceScoreCard}
                            getTableState={getTableState}
                            rowClick={rowClick}
                            check={check}
                            selectedIDs={selectedIDs}
                            getTrProps={getTrProps}
                            x
                            checkboxlogo
                          />
                        </>
                      ) : params.view_type === "SITE_MIS" ? (
                        <>
                          <ScrollableReactTable
                            columns={columnsSiteMis}
                            data={listSiteMIS}
                            getTableState={getTableState}
                            rowClick={rowClick}
                            check={check}
                            selectedIDs={selectedIDs}
                            getTrProps={getTrProps}
                            checkboxlogo
                          />
                        </>
                      ) : params.view_type ===
                        "VENDOR-WISE_TRENDS_PAN_INDIA" ? (
                        <ScrollableReactTable
                          columns={VendorWiseTrendsColumns}
                          data={listVendorWiseTrends}
                          getTableState={getTableState}
                          rowClick={rowClick}
                          check={check}
                          selectedIDs={selectedIDs}
                          getTrProps={getTrProps}
                          checkboxlogo
                        />
                      ) : params.view_type ===
                        "REPEAT_ERRORS_AND_PERIODICITY_OF_NON-COMPLIANCE" ? (
                        <ScrollableReactTable
                          columns={RepeatErrorsandPeriodicityColumns}
                          data={repeatErrorsandPeriodicity}
                          getTableState={getTableState}
                          rowClick={rowClick}
                          check={check}
                          selectedIDs={selectedIDs}
                          getTrProps={getTrProps}
                          checkboxlogo
                        />
                      ) : (
                        <ScrollableReactTable
                          columns={columns}
                          data={list}
                          getTableState={getTableState}
                          rowClick={rowClick}
                          check={check}
                          selectedIDs={selectedIDs}
                          getTrProps={getTrProps}
                          checkboxlogo
                        />
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  {Object.keys(params).length !== 0 ? (
                    <>
                      <ManageAuditNotfound />
                    </>
                  ) : (
                    <>
                      <ManageAuditNotfound />
                    </>
                  )}
                </>
              )}
            </div>

            <FooterWrapper
              list={
                params.view_type === "SITE_MIS"
                  ? listSiteMIS
                  : params.view_type === "COMPLIANCE_SCORE_CARD"
                  ? listComplianceScoreCard
                  : params.view_type === "VENDOR-WISE_TRENDS_PAN_INDIA"
                  ? listVendorWiseTrends
                  : params.view_type ===
                    "REPEAT_ERRORS_AND_PERIODICITY_OF_NON-COMPLIANCE"
                  ? repeatErrorsandPeriodicity
                  : list
              }
              totalCount={totalCount}
              limit={limit}
              page_no={page_no}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
            />
          </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default ManageAudit;